// Angular
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { APP_PROPS } from '../../cai-common.module';
import { ApplicationProperties } from '../../core/_base/layout/models/app-properties.model';
import { SplashScreenService } from '../../core/_base/layout/services/splash-screen.service';
import { environment } from '../../environments';

@Component({
  selector: 'kt-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: false,
})
export class RegisterComponent implements OnInit {
  // Public properties
  today: number = Date.now();
  headerLogo: string;
  features = environment.features;
  isGuestUser: boolean;

  /**
   * Component constructor
   *
   * @param el
   * @param render
   * @param layoutConfigService: LayoutConfigService
   * @param splashScreenService: SplashScreenService
   */
  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private el: ElementRef,
    private render: Renderer2,
    private splashScreenService: SplashScreenService,
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.headerLogo = this.appProperties.logo;
    this.splashScreenService.hide();
    if (environment.datadog) {
      datadogRum.addFeatureFlagEvaluation('i18n', this.features.i18n);
    }
  }

  get isWalletApp(): boolean {
    return this.appProperties.name === 'cargowallet';
  }
}
